import React, {
    useState,
    useEffect
}                               from 'react'    
import UiKit                    from "../../../../../common/uikit"  
import parse                    from "react-html-parser"    
import {
    useDomain
}                               from '../../../../../hooks/use';
import { useSelector }          from 'react-redux';

const Edit = props => {
    const redux         = useSelector( state => ({
        isLoading       : state.getIn([ 'ui', 'provider', 'isLoading', 'Get_Blog' ]),
        blog            : state.getIn([ 'domain', 'blog', 'details' ]),
    }));
    const { blog }          = useDomain({ Blog: {} });
    const [data, setData]   = useState("");
    const [lan, setLan]     = useState();
    const blogDetails      = redux.blog && redux.blog.toJS() || [];
    console.log(blogDetails);
    
    useEffect(() => {
        blog.clearBlogDetails()
        blog.getBlogDetails({ id: props.data.blog_id })
    }, [])

    return (
        <div className="add-blog-container"> 
        <div>
        <form className="form-wrapper">
                <UiKit.Row className="mt25">
                    <UiKit.Col className="p8" sm="12" md="12">
                        <UiKit.Textfield
                            full
                            required
                            placeholder = "blog title"
                            // value       = { s.form.website }
                            // onChange    = { value => changeFormValues('website', value) }
                            // errors      = { s.errors['website'] }
                            // isDisabled  = { redux.isLoading }
                            // attrs       = { { id: 'sign-up-website' } }
                        />
                    </UiKit.Col>
                </UiKit.Row>
                <UiKit.Row className="mt25">
                    <UiKit.Col className="p8"sm="12" md="12">
                        <div className="file-upload">
                            <input type="file" name="file"  placeholder="resim sec"/>
                        </div>
                    </UiKit.Col>
                </UiKit.Row>
            </form>
        </div>
            <div className="blog-text">
                <p>Blog detayi giriniz</p>
                <div className="editor">
                    <UiKit.Editor 
                        data    = {data}
                        edit    = { (value) => setData(value) }
                        plugIns = {[ 'key-binder' ]}
                    />
                </div>
            </div>
           <div className="show-wrapper">
                <h1>Son Haline Göz At 🧐</h1>
                <div className="show-blog">
                    {data && parse(data)}
                </div>
           </div>
           <div className="footer">
               <button>Güncelle</button>
           </div>
        </div>
    )
}

export default Edit
